var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{on:{"childrenRoute":_vm.hideNonChildren}}),(!_vm.isChildRoute)?_c('div',[_c('div',{staticClass:"row p-4"},[_c('div',{staticClass:"col-md-12"},[_c('OverviewMaintenance')],1)])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }